import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        // Send session_id to backend
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        if (response.data?.user) {
          // Clear the hash from URL.
          window.history.replaceState(null, '', window.location.pathname);
          // Iter495 — Google OAuth users land without a phone. Send them
          // through /complete-profile until one is provided.
          const u = response.data.user;
          const UK_PHONE_RE = /^07\d{9}$/;
          const isAdmin = ['admin', 'superadmin'].includes(u.role);
          const needsPhone = !u.phone || !UK_PHONE_RE.test(String(u.phone).replace(/\s/g, ''));
          if (!isAdmin && needsPhone) {
            navigate('/complete-profile', { replace: true, state: { user: u } });
          } else {
            navigate('/', { replace: true, state: { user: u } });
          }
        } else {
          throw new Error('No user data received');
        }
      } catch (error) {
        navigate('/login', { 
          replace: true,
          state: { error: 'Sign-in failed. Please try again.' }
        });
      }
    };

    processAuth();
  }, [navigate, location.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="w-16 h-16 animate-spin text-emerald-900 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-emerald-900 mb-2">Signing in...</h2>
        <p className="text-muted-foreground">Please wait, redirecting…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
